import { company as companyFields } from "../AddCustomerForm/config";

export const editFormFields = companyFields
  .filter((field) =>
    [
      "company_name",
      "website",
      "company_phone",
      "company_email",
      "company_street_address",
      "company_country_id",
      "company_state_id",
      "company_city_id",
      "company_postal_code",
      "tax_id",
    ].includes(field.name)
  )
  .map((field) => ({
    ...field,
    options:
      field.name.includes("country") ||
      field.name.includes("state") ||
      field.name.includes("city")
        ? []
        : field.options,
    asyncOptions: false,
  }));
